import { Reducer } from 'redux';
import { KpiSETypes, KpiSEState } from './types';

const INITIAL_STATE: KpiSEState = {
  data: [],
  error: false,
  loading: false,
};

const reducer: Reducer<KpiSEState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case KpiSETypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case KpiSETypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case KpiSETypes.LOAD_FAILURE:
      return { ...state, loading: false, error: true, data: INITIAL_STATE.data };
    default:
      return state;
  }
};

export default reducer;
